// Global side-panel state for athlete financials. The panel is mounted once
// in the main layout; any page opens it via `financialsPanel/open`.

export const state = {
    athleteId: null,
};

export const mutations = {
    OPEN(state, athleteId) {
        state.athleteId = athleteId;
    },
    CLOSE(state) {
        state.athleteId = null;
    },
};

export const actions = {
    open({commit}, athleteId) {
        commit('OPEN', athleteId);
    },
    close({commit}) {
        commit('CLOSE');
    },
};
